import { isValidURL } from '../utils/location';
import { useSearchParam } from './useSearchParam';

export const useBackURLFromQuery = () => {
  const backURL = useSearchParam('backURL');
  return isValidURL(backURL) ? backURL : null;
};
